/**
 * We export a default string in places where we want N/A as a default value but leaving as a constant here in case there is a need to change this string in one place
 */
if ("NA" in window === false) window.NA = "N/A";
